
import { FaShoppingCart, FaEgg } from 'react-icons/fa';

const Navbar = ({ cartCount, toggleCart }) => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <FaEgg className="navbar-icon" />
          <h1>EGG FOR ALL</h1>
        </div>
        <div className="navbar-cart" onClick={toggleCart}>
          <FaShoppingCart className="cart-icon" />
          <span className="cart-count">{cartCount}</span>
          <span className="cart-text">Cart</span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;